import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";

export type PricingOption = "1-month" | "3-month" | "12-month";

export interface PricingPlan {
    id: PricingOption;
    label: string;
    originalPrice: number;
    currentPrice: number;
    pricePerMonth: number;
    isPopular?: boolean;
}

@Component({
    selector: "app-pricing-card",
    imports: [CommonModule],
    templateUrl: "./pricing-card.component.html",
    styleUrl: "./pricing-card.component.scss",
    standalone: true
})
export class PricingCardComponent {
    @Input() plan!: PricingPlan;
    @Input() selectedPricing!: PricingOption;
    @Output() selected = new EventEmitter<PricingOption>();

    selectPlan() {
        this.selected.emit(this.plan.id);
    }
}

